export const getStatusText = (status: string) => {
  switch (status) {
    case "active":
      return "Registrado";
    case "pending":
      return "Pendiente";
    case "expired":
      return "Vencido";
    default:
      return status;
  }
};
